import IDicomBuilder from 'app/interfaces/IDicomBuilder';
import React from 'react';

const DicomBuilderContext = React.createContext<IDicomBuilder>(undefined);

export default DicomBuilderContext;
